import script from "./SettingsTimecardContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsTimecardContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsTimecardContent.vue?vue&type=style&index=0&id=05634ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05634ef8"]])

export default __exports__